import { JsonObject, JsonProperty } from 'json2typescript';
import { Connection } from './connection';
import { MapStation } from '../../../core/models/map-station';

/**
 * Třída pro příjem dat ze serveru
 */
@JsonObject("MapModel")
export class MapModel {
  /** výchozí přiblížení */
  @JsonProperty('initialZoom', Number)
  initialZoom: number | undefined = undefined

  @JsonProperty('lat', Number)
  lat: number | undefined = undefined

  @JsonProperty('lng', Number)
  lng: number | undefined = undefined

  @JsonProperty('connections', [Connection], true)
  connections: Connection[] | undefined = undefined
  
  @JsonProperty('stops', [MapStation], true)
  stops: MapStation[] | undefined = undefined
  
  /** obnovování poloh v mapě v sekundách */
  @JsonProperty('refreshInterval', Number)
  refreshInterval: number = 0
}
